export default {"src":"/_next/static/media/loading-circle.6af05dee.gif","height":297,"width":297};